export default __webpack_public_path__ + "static/media/Hashh.5cba6886.png";